import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../../../components/UI/Table/Table";
import {
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import classnames from "classnames";
import debounce from "lodash.debounce";
import {
  getUsersList,
  updateUserStatus,
  addAdminAnalyst,
  resetAddAdminAnalystStatus,
  VALIDATE_CORPORATE
} from "./action";
import { downloadUsersCSV } from './action';
import { Preloading } from "../../../components/UI/Preloader/action";
import Preloader from "../../../components/UI/Preloader";
import { GridLoader } from "react-spinners";

const roleConfig = {
  admin: {
    title: "Download active admin user list in CSV format",
    label: "Download",
  },
  analyst: {
    title: "Download active analyst user list in CSV format",
    label: "Download",
  },
  corporate: {
    title: "Download active corporate user list in CSV format",
    label: "Download",
  },
};



const roleMap = {
  admin: {
    label: "Admin",
    roleValue: "RUBIXADMIN",
  },
  analyst: {
    label: "Analyst",
    roleValue: "RUBIXANALYST",
  },
};

class AllUserListComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "admin",
      searchText: "",
      page: 0,
      pageSize: 10,
      showConfirmModal: false,
      selectedUserId: null,
      selectedUserStatus: null,
      showAddAdminAnalystModal: false,
      newAdminAnalystFirstName: "",
      newAdminAnalystLastName: "",
      newAdminAnalystEmail: "",
      isAddingAdminAnalyst: false,   
       addAdminAnalystFormErrors: {
          firstName: "",
          lastName: "",
          email: "",
        },

      showCorporateValidateModal: false,
      corporateInputId: "",
      corporateDetails: null,
      corporateValidationError: "",
      isCorporateValidating: false,
      pendingCorporateStatusChange: null, 
    };

    this.debouncedSearch = debounce(() => {
      this.setState({ page: 0 }, this.fetchUsers);
    }, 500);
  }

  componentDidMount() {
    this.fetchUsers();
  }
  componentDidUpdate(prevProps) {
  if (
    this.props.addAdminAnalystSuccess &&
    prevProps.addAdminAnalystSuccess  !== this.props.addAdminAnalystSuccess 
  ) {
    
    this.setState({ isAddingAdminAnalyst: false });  
    this.props.preloading(false);

    this.setState({
      corporateInputId: "",
      corporateDetails: null,
      pendingCorporateStatusChange: null,
    });
  
    this.closeAddAdminAnalystModal();
    this.props.resetAddAdminAnalystStatus();
    this.fetchUsers(); 
  }

  if (
    this.props.addAdminAnalystFailure  &&
    prevProps.addAdminAnalystFailure  !== this.props.addAdminAnalystFailure 
  ) {
    this.setState({ isAddingAdminAnalyst: false });  
    this.props.preloading(false);
  }

  if (prevProps.usersListSuccess !== this.props.usersListSuccess) {
    this.props.preloading(false);
  }
}

  fetchUsers = () => {
    const { activeTab, searchText, page, pageSize } = this.state;
    this.props.preloading(true);
    this.props.getUsersList(activeTab, searchText, page, pageSize);
  };

  changeTab = (tab) => {
    this.setState(
      {
        activeTab: tab,
        page: 0,
        pageSize: 10,
        searchText: "",
        addAdminAnalystFormErrors: {
          firstName: "",
          lastName: "",
          email: "",
        },
      },
      this.fetchUsers
    );
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch();
  };

  handlePageChange = (pageIndex) => {
    this.setState({ page: pageIndex }, this.fetchUsers);
  };

  handlePageSizeChange = (newPageSize) => {
    this.setState({ pageSize: newPageSize, page: 0 }, this.fetchUsers);
  };

  openConfirmModal = (id, status) => {
    this.setState({
      showConfirmModal: true,
      selectedUserId: id,
      selectedUserStatus: status,
    });
  };

  closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      selectedUserId: null,
      selectedUserStatus: null,
    });
  };

  confirmStatusChange = () => {
    const {
      activeTab,
      page,
      selectedUserId,
      selectedUserStatus,
      pageSize,
      searchText,
      corporateInputId,
    } = this.state;
    const newStatus = selectedUserStatus === "active" ? "inactive" : "active";

    this.props.preloading(true);
    this.props.updateUserStatus(
      activeTab,
      selectedUserId,
      newStatus,
      page,
      pageSize,
      searchText,
      activeTab === "corporate" && newStatus === "active"
      ? corporateInputId
      : null
    );
    this.closeConfirmModal();
  };

handleStatusClick = (user, status) => {
  const { activeTab } = this.state;

  const isActivating = status === "inactive"; 
  if (activeTab === "corporate" && isActivating) {
    this.setState({
      showCorporateValidateModal: true,
      corporateInputId: "",
      corporateDetails: null,
      corporateValidationError: "",
      pendingCorporateStatusChange: {
        userId: user.id,
        status,
      },
    });
  } else {
    this.openConfirmModal(user.id, status);
  }
};



validateCorporate = () => {
  const { corporateInputId } = this.state;

  if (!corporateInputId) {
    this.setState({ corporateValidationError: "Corporate ID required" });
    return;
  }

  this.setState({ isCorporateValidating: true });

  this.props.validateCorporateId(corporateInputId, (err, data) => {
    this.setState({ isCorporateValidating: false });

    if (err || !data) {
      this.setState({
        corporateValidationError: "Enter valid corporate ID",
        corporateDetails: null,
      });
      return;
    }

    this.setState({
      corporateDetails: data,
      corporateValidationError: "",
    });
  });
};

proceedCorporateConfirm = () => {
  const { pendingCorporateStatusChange } = this.state;

  this.setState({
    showCorporateValidateModal: false,
  });

  this.openConfirmModal(
    pendingCorporateStatusChange.userId,
    pendingCorporateStatusChange.status
  );
};

handleAddAdminAnalyst = () => {
  const {
    newAdminAnalystFirstName,
    newAdminAnalystLastName,
    newAdminAnalystEmail,
    activeTab,
    page,
    pageSize,
    searchText,
  } = this.state;

  const firstName = newAdminAnalystFirstName?.trim();
  const lastName = newAdminAnalystLastName?.trim();
  const email = newAdminAnalystEmail?.trim();

  let errors = {};

  if (!firstName) errors.firstName = "First name is required";
  if (!lastName) errors.lastName = "Last name is required";
  if (!email) errors.email = "Email is required";

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (email && !emailRegex.test(email)) {
    errors.email = "Enter valid email address";
  }

  if (Object.keys(errors).length > 0) {
    this.setState({ addAdminAnalystFormErrors: errors });
    toast.error("Please fix the errors in the form");
    return;
  }

  this.setState({
    addAdminAnalystFormErrors: { firstName: "", lastName: "", email: "" },
    isAddingAdminAnalyst : true
  });
      this.props.preloading(true);


  const roleValue =
    activeTab === "admin" ? "RUBIXADMIN" : "RUBIXANALYST";

  const payload = {
    username: email,
    firstname: firstName,
    lastname: lastName,
    email,
    role: roleValue,
    page,
    pageSize,
    keyword: searchText,
    activeTab,
  };

  this.props.addAdminAnalyst(payload);
};

  resetAddAdminAnalystInputs = () => {
    this.setState({
      newAdminAnalystFirstName: "",
      newAdminAnalystLastName: "",
      newAdminAnalystEmail: "",
      addAdminAnalystFormErrors: {
      firstName: "",
      lastName: "",
      email: "",
    },
    });
  };

  openAddAdminAnalystModal = () => {
    this.resetAddAdminAnalystInputs();
    this.setState({ showAddAdminAnalystModal: true });
  };

  closeAddAdminAnalystModal = () => {
    this.setState({ showAddAdminAnalystModal: false });
    this.resetAddAdminAnalystInputs();
  };

  getColumns = () => {
    const { activeTab } = this.state;
    return [
      {
        Header: "First Name",
        accessor: (row) => row.fullName?.split(" ")[0] || "",
        id: "firstName",
        className: "center",
      },
      {
        Header: "Last Name",
        accessor: (row) => row.fullName?.split(" ")[1] || "",
        id: "lastName",
        className: "center",
      },
      { Header: "Email", accessor: "email", className: "center" },
      ...(activeTab === "corporate"
        ? [
            {
              Header: "Corporate Id",
              accessor: "corporateId",
              className: "center",
            },
          ]
        : []),
      {
        Header: "Status",
        accessor: "enabled",
        id: "status",
        className: "center",
        Cell: ({ row }) => {
          const user = row?.original || row?._original || row;
          if (!user) return <span>--</span>;

          const isActive = !!user.enabled;
          const isSelf = user.username === localStorage.getItem("username");
          const disableButton = isSelf && isActive;

          return (
            <Button
              size="sm"
              color={isActive ? "success" : "danger"}
              disabled={disableButton}
              // onClick={() =>
              //   !disableButton &&
              //   this.openConfirmModal(user.id, isActive ? "active" : "inactive")
              // }
              onClick={() =>
                !disableButton &&
                this.handleStatusClick(user, isActive ? "active" : "inactive")
              }
            >
              {isActive ? "Active" : "Inactive"}
            </Button>
          );
        },
      },
    ];
  };

  render() {
    const {
      activeTab,
      page,
      pageSize,
      showConfirmModal,
      selectedUserStatus,
      searchText,
      showAddAdminAnalystModal,
    } = this.state;
    const userState = this.props.usersListSuccess[activeTab] || {
      content: [],
      totalPages: 0,
    };
    const nextStatus = selectedUserStatus === "active" ? "inactive" : "active";

    return (
      <Col>
        <div className="d-flex justify-content-between mb-3">
          <h4>All Users</h4>
          <input
            type="text"
            className="form-control"
            style={{ width: "260px" }}
            placeholder="Search by name or email..."
            value={searchText}
            onChange={this.handleSearchChange}
          />
        </div>
          <div className="d-flex align-items-center justify-content-between w-100 mb-3">
            {/* LEFT: Tabs */}
            <ul className="nav nav-pills gap-2 mb-0">
              {["admin", "analyst", "corporate"].map((tab) => (
                <li className="nav-item" key={tab}>
                  <button
                    className={classnames("nav-link px-4", {
                      active: activeTab === tab,
                    })}
                    onClick={() => this.changeTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)} Users
                  </button>
                </li>
              ))}
            </ul>

            {/* RIGHT: Buttons */}
            <div className="d-flex align-items-center gap-2">
              {/* Add Admin only for admin */}
              {(activeTab === "admin" || activeTab === "analyst") && (
                <Button
                  color="outline-success"
                  onClick={this.openAddAdminAnalystModal}
                  title={`Add ${roleMap[activeTab].label}`}
                >
                  <i className="fa fa-user-plus me-1"></i>
                  Add {roleMap[activeTab].label}
                </Button>
              )}

              {/* Download only for admin & analyst */}
              {activeTab !== "corporate" && (
                <Button
                  color="outline-success"
                   onClick={() => this.props.downloadUsersCSV(activeTab,this.props.preloading)}
                  title={roleConfig[activeTab].title}
                >
                  <i className="fa fa-download me-1"></i>
                  {roleConfig[activeTab].label}
                </Button>
              )}
            </div>
          </div>
        <Card>
          <CardBody>
            <div className="table-responsive-md">
              <Table
                key={activeTab}
                data={userState.content}
                columns={this.getColumns()}
                manual
                page={page}
                pageSize={pageSize}
                pages={userState.totalPages}
                onPageChange={this.handlePageChange}
                onPageSizeChange={this.handlePageSizeChange}
              />
            </div>
          </CardBody>
        </Card>

        {/* Confirm Status Modal */}
        <Modal
            isOpen={showConfirmModal}
            toggle={this.closeConfirmModal}
          >
          <ModalHeader toggle={this.closeConfirmModal}>
            Confirm Action
          </ModalHeader>
          <ModalBody>
            Are you sure you want to mark this user as{" "}
            <strong>{nextStatus}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.closeConfirmModal}>Cancel</Button>
            <Button color="danger" onClick={this.confirmStatusChange}>
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
        




<Modal
  isOpen={this.state.showCorporateValidateModal}
  toggle={() =>
    this.setState({ showCorporateValidateModal: false })
  }
  centered
  size="sm"
>
  {/* Header */}
  <ModalHeader
    toggle={() =>
      this.setState({ showCorporateValidateModal: false })
    }
  >
    Corporate Status Validation
  </ModalHeader>

  {/* Body */}
  <ModalBody>

    {/* Corporate ID Input */}
    <div className="mb-4">
      <label className="form-label">
        Corporate ID
      </label>

      {/* Input + Validate Button */}
      <div className="d-flex justify-content-between align-items-center gap-3">

        {/* Normal Size Input */}
        <input
          type="text"
          className={`form-control ${
            this.state.corporateValidationError
              ? "is-invalid"
              : ""
          }`}
          placeholder="Enter Corporate ID"
          value={this.state.corporateInputId}
          onChange={(e) =>
            this.setState({
              corporateInputId: e.target.value,
              corporateValidationError: "",
              corporateDetails: null,
            })
          }
          style={{
            width: "250px",
            fontSize: "16px",
            height: "38px",
          }}
        />

        {/* Validate Button */}
        <button
          className="btn btn-primary"
          style={{
            height: "38px",
            padding: "0 16px",
            fontSize: "14px",
          }}
          onClick={this.validateCorporate}
          disabled={this.state.isCorporateValidating}
        >
          {this.state.isCorporateValidating ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            "Validate"
          )}
        </button>
      </div>

      {/* Error Message */}
      {this.state.corporateValidationError && (
        <div className="text-danger mt-2 small">
          <i className="fa fa-exclamation-circle me-1"></i>
          {this.state.corporateValidationError}
        </div>
      )}
    </div>

    {/* Corporate Details */}
    {this.state.corporateDetails && (
      <div
        className="border rounded p-3 mb-3"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <div className="mb-3">
          <strong>ID:</strong>
          <br />
          {this.state.corporateDetails.id}
        </div>

        <div className="mb-3">
          <strong>Name:</strong>
          <br />
          {this.state.corporateDetails.corporateName}
        </div>

        {/* Continue Button Right Side */}
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-success"
            style={{
              height: "38px",
              padding: "0 18px",
              fontSize: "14px",
            }}
            onClick={this.proceedCorporateConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    )}
  </ModalBody>

  {/* Footer */}
  <ModalFooter>
    <Button
      color="secondary"
      style={{
        height: "38px",
        padding: "0 18px",
        fontSize: "14px",
      }}
      onClick={() =>
        this.setState({
          showCorporateValidateModal: false,
          corporateInputId: "",
          corporateDetails: null,
          corporateValidationError: "",
          pendingCorporateStatusChange: null,
        })
      }
    >
      Cancel
    </Button>
  </ModalFooter>
</Modal>















       {/* Add Admin / Analyst Modal */}
        <Modal
          isOpen={showAddAdminAnalystModal}
          toggle={this.closeAddAdminAnalystModal}
          backdrop="static"
          centered
        >
          <ModalHeader toggle={this.closeAddAdminAnalystModal}>
            Add {roleMap[activeTab]?.label}
          </ModalHeader>

          <ModalBody style={{ position: 'relative' }}>
              {this.state.isAddingAdminAnalyst && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                borderRadius: '4px',
                // backgroundColor: 'rgba(0, 0, 0, 0.3)'
              }}>
                <div>
                  <GridLoader size={20} color="#00BFFF" loading={true} />
                </div>
              </div>
            )}

            {/* First Name */}
            <div className={this.state.isAddingAdminAnalyst ? "opacity-50" : ""}>
            <div className="mb-3">
              <label className="form-label">
                First Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  this.state.addAdminAnalystFormErrors?.firstName ? "is-invalid" : ""
                }`}
                value={this.state.newAdminAnalystFirstName}
                onChange={(e) =>
                  this.setState({
                    newAdminAnalystFirstName: e.target.value,
                    addAdminAnalystFormErrors: { ...this.state.addAdminAnalystFormErrors, firstName: "" },
                  })
                }
                disabled={this.state.isAddingAdminAnalyst}
              />
              {this.state.addAdminAnalystFormErrors?.firstName && (
                <div className="text-danger small">
                  {this.state.addAdminAnalystFormErrors.firstName}
                </div>
              )}
            </div>

            {/* Last Name */}
            <div className="mb-3">
              <label className="form-label">
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  this.state.addAdminAnalystFormErrors?.lastName ? "is-invalid" : ""
                }`}
                value={this.state.newAdminAnalystLastName}
                onChange={(e) =>
                  this.setState({
                    newAdminAnalystLastName: e.target.value,
                    addAdminAnalystFormErrors: { ...this.state.addAdminAnalystFormErrors, lastName: "" },
                  })
                }
                disabled={this.state.isAddingAdminAnalyst}
              />
              {this.state.addAdminAnalystFormErrors?.lastName && (
                <div className="text-danger small">
                  {this.state.addAdminAnalystFormErrors.lastName}
                </div>
              )}
            </div>

            {/* Email */}
            <div className="mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className={`form-control ${
                  this.state.addAdminAnalystFormErrors?.email ? "is-invalid" : ""
                }`}
                value={this.state.newAdminAnalystEmail}
                onChange={(e) =>
                  this.setState({
                    newAdminAnalystEmail: e.target.value,
                    addAdminAnalystFormErrors: { ...this.state.addAdminAnalystFormErrors, email: "" },
                  })
                }
                disabled={this.state.isAddingAdminAnalyst}
              />
              {this.state.addAdminAnalystFormErrors?.email && (
                <div className="text-danger small">
                  {this.state.addAdminAnalystFormErrors.email}
                </div>
              )}
            </div>

            {/* Role */}
            <div className="mb-3">
              <label className="form-label">Role</label>
              <input
                type="text"
                className="form-control"
                value={roleMap[activeTab]?.roleValue}
                readOnly
                disabled={this.state.isAddingAdminAnalyst}
              />
            </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={this.closeAddAdminAnalystModal}>
              Cancel
            </Button>

            <Button color="primary" onClick={this.handleAddAdminAnalyst}>
              {activeTab === "admin" ? "Add Admin" : "Add Analyst"}
            </Button>
          </ModalFooter>
        </Modal>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  usersListSuccess: state.allUserList.usersListSuccess,
  updateUserStatusFailure: state.allUserList.updateUserStatusFailure,
  addAdminAnalystFailure: state.allUserList.addAdminAnalystFailure,
  addAdminAnalystSuccess: state.allUserList.addAdminAnalystSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  getUsersList: (role, keyword, page, size) =>
    dispatch(getUsersList(role, keyword, page, size)),
  updateUserStatus: (role, id, status, page, size, keyword,corporateId) =>
    dispatch(updateUserStatus(role, id, status, page, size, keyword,corporateId)),
  addAdminAnalyst: (payload) => dispatch(addAdminAnalyst(payload)),
  resetAddAdminAnalystStatus: () => dispatch(resetAddAdminAnalystStatus()),
  preloading: (isPreloading) => dispatch(Preloading(isPreloading)),
  downloadUsersCSV: (tab, preloading) => dispatch(downloadUsersCSV(tab, preloading)),
  validateCorporateId: (id, callback) =>
  dispatch({
    type: VALIDATE_CORPORATE,
    payload: id,
    callback,
  }),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUserListComponent);
